<template>
    <div class="contact-index">
        <!--banner-->
        <div class="contact">
            <banHead :bannerHead="banHead"></banHead>
        </div>
        <section>
            <!--contact-->
            <div class="contact-cont">
                <div class="contact-mes center">
                    <addr></addr>
                </div>
            </div>
            <!--content2-->
            <div class="partner-cont">
                <div class="partner center">
                    <div class="partner-mes">
                        <message :detailMsg="partnerMsg"></message>
                        <p class="join">Join us </p>
                    </div>
                    <!--contact form-->
                    <div class="contact-form" id="prod_order">
                        <Request :item="orderRequestItem" :submit="orderRequestSubmit"></Request>
                    </div>
                </div>
            </div>

        </section>
    </div>
</template>

<script>
    import banHead from '../common/banHead';
    import addr from '../common/addr';
    import message from '../common/message';
    import Request from '../common/Request'

    export default {
        name: "contact",
        data() {
            return {
                banHead: {
                    title: 'Contact',
                    msg: 'At SENSORO, providing high-quality customer care and service is a business priority',
                    _src: '/static/image/contact/Contact-banner@2x.jpg'
                },
                partnerMsg: {
                    title: 'Partner Opportunity',
                    msg: 'Sensoro is committed to delivering effective IoT solutions all over the world. Do you share our vision for the success of our customers and communities?'
                },
                noteShow: true,
                orderRequestItem: null,
            }
        },
        created() {
            // this.submitContact()
        },
        mounted() {
            this.utils.getImg()
        },
        methods: {
            hideNote() {
                this.noteShow = false;
            },
            // 订购信息提交
            orderRequestSubmit(data) {
                // this.$http.post(`${this.config.IOT_API_URL}/anonymous/contact`, data).then(ret => {
                //     let body = ret.body;
                this.orderRequestModalShowFlag = false;
                // })
            }
        },
        components: {
            banHead,
            addr,
            message,
            Request
        }
    }
</script>

<style lang="less">
    .contact-index {
        @baseWidth: 1640px;
        width: 100%;
        .common-font{
            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }
        .center {
            width: @baseWidth;
            margin: 0 auto;
        }
        /*banner*/
        .contact {
            width: 100%;
            /*banner*/
            .com-banner {
                background: url("/static/image/contact/Contact-banner@1x.jpg") no-repeat center;
                .banner-pro p {
                    width: 520px;
                }
            }

        }
        /*content*/
        section {
            .contact-cont {
                background: #f4f4f4;
                .contact-mes {
                    padding: 96px 140px;
                    .addr-mes {
                        padding: 0 140px;
                        .addr-detail {
                            display: flex;
                            justify-content: space-between;
                            li p {
                                width: 300px;
                            }
                        }
                    }
                }
            }
            .partner-cont {
                margin: 96px 0;
                .partner {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .partner-mes {
                        width: 40%;

                        .join {
                            font-size: 18px;
                            color: #252525;
                            margin-top: 33px;
                        }
                    }
                    .contact-form {
                        position: relative;
                        ul {
                            li {
                                position: relative;
                                display: flex;
                                justify-content: space-between;
                                margin-bottom: 32px;
                                width: 800px;
                                color: #B6B6B6;
                                input, textarea, button {
                                    -ms-appearance: none;
                                    -webkit-appearance: none;
                                    appearance: none;
                                    outline: none;
                                    /*transition: .3s;*/
                                    padding: 0 8px;
                                    border: none;
                                    font-size: 18px;
                                    line-height: 22px;
                                    &:focus {
                                        /*box-shadow: 0 0 15px #e4e4e4 inset;*/
                                    }
                                    &.has-error {
                                        background: rgba(200, 71, 71, 0.44);
                                    }

                                    &:disabled {
                                        color: #a6a6a6 !important;
                                    }

                                }
                                input {
                                    /*width: 380px;*/
                                    height: 48px;
                                    line-height: 48px;
                                    background: #fafafa;

                                }
                                button {
                                    width: 180px;
                                    height: 58px;
                                    background: #fff;
                                    border: 1px solid #a6a6a6;
                                    -webkit-transition: .3s;
                                    -moz-transition: .3s;
                                    -ms-transition: .3s;
                                    -o-transition: .3s;
                                    transition: .3s;
                                    &:hover {
                                        background: #252525;
                                        color: #fff;
                                    }
                                }

                            }
                            .option {
                                position: relative;
                                height: 178px;
                                textarea {
                                    position: absolute;
                                    width: 100%;
                                    height: 178px;
                                    resize: none;
                                    background: #fafafa;
                                    padding: 8px;
                                }
                                .note {
                                    position: absolute;
                                    padding: 8px;
                                    font-size: 18px;
                                    line-height: 26px;
                                }
                            }
                        }
                        .success-res {
                            position: absolute;
                            z-index: 0;
                            top: 0;
                            width: 100%;
                            text-align: center;

                            opacity: 0;

                            .txt {
                                color: #49a24c;
                                text-shadow: 0px 1px 1px #49a24c;
                            }

                            /*transition: .55s ease-out;*/
                            &.show {
                                opacity: 1;
                                top: -30px;
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1680px) {
        @baseWidth: 1216px;
        @autoWidth: 1256px;
        .contact-index {
            width: 100%;
            min-width: @autoWidth;
            .center {
                width: @baseWidth;
                margin: 0 auto;
            }
            section {
                .contact-cont {
                    .contact-mes {
                        padding: 96px 0;
                        .addr-mes {
                            padding: 0;
                        }
                    }
                }
                .partner-cont {

                    .partner {
                        .partner-mes {
                            width: 32%;
                        }
                        .contact-form {
                            ul {
                                li {
                                    width: 732px;
                                    .companyName, .advisoy {
                                        width: 800px;
                                    }
                                    .fullName, .phoneNumber, .emailAdress, .country {
                                        width: 340px;
                                        input {
                                            width: 100%;
                                        }
                                        label {
                                            display: block;
                                            width: 100%;
                                        }
                                    }
                                }
                                .option {
                                    position: relative;

                                }
                            }
                        }
                    }
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/contact.vue